import React, { useEffect, useRef } from 'react';

export default function Toast({ message, type = 'success', onDone }) {
  const isError = type === 'error';
  const isInfo = type === 'info';
  // onDone kommt als Inline-Arrow — im Ref halten, sonst startet der Timer bei jedem Re-Render neu
  const onDoneRef = useRef(onDone);
  useEffect(() => { onDoneRef.current = onDone; });
  useEffect(() => {
    const t = setTimeout(() => onDoneRef.current(), isError ? 5000 : isInfo ? 4000 : 2500);
    return () => clearTimeout(t);
  }, [message, isError, isInfo]);
  return (
    <div role="status" aria-live="polite" style={{
      position: 'fixed', bottom: 28, left: '50%', transform: 'translateX(-50%)',
      background: isError ? '#dc2626' : isInfo ? '#2563eb' : '#16a34a', color: 'white', padding: '10px 22px',
      borderRadius: 10, fontWeight: 600, fontSize: 14,
      boxShadow: '0 4px 16px rgba(0,0,0,0.18)', zIndex: 'var(--z-toast)',
      animation: 'fadeInUp 0.2s ease',
      display: 'flex', alignItems: 'center', gap: 8,
    }}>
      {isError ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      ) : isInfo ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M17.5 19a4.5 4.5 0 0 0 0-9 6 6 0 0 0-11.4-2A5 5 0 0 0 6 18h11.5z"/>
          <polyline points="10 13 12 15 15 10.5"/>
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      )}
      {message}
    </div>
  );
}
